import { ref, computed } from 'vue'
import { fetchPaymentOptions } from '../utils/fetchPaymentOptions.js'

// Dias de teste grátis (parâmetro do backend, ver GET /api/public/payment-options).
// Estado de módulo: uma única consulta, compartilhada por todos os CTAs.
const trialDays = ref(0)
let loading = null

export function useTrialCta() {
  if (!loading) {
    loading = fetchPaymentOptions().then((opts) => { trialDays.value = opts.trialDays })
  }

  // Texto do CTA de cadastro; sem teste configurado, mantém o `fallback` original.
  const ctaLabel = (fallback) => (trialDays.value > 0
    ? `Teste grátis por ${trialDays.value} ${trialDays.value === 1 ? 'dia' : 'dias'}`
    : fallback)

  return { trialDays, hasTrial: computed(() => trialDays.value > 0), ctaLabel }
}
